"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyGenerator = void 0;
class KeyGenerator {
    static { this.last = 0; }
    static next() {
        this.last += 1;
        return this.last;
    }
}
exports.KeyGenerator = KeyGenerator;
//# sourceMappingURL=KeyGenerator.js.map